import { ErrorBase } from "@util/errors";
import { MonthString } from "@util/types";

export class CustomerNotFoundError extends ErrorBase {
	static errorId = "customer-not-found";
	constructor() {
		super("Der Kunde wurde nicht gefunden.");
	}
}

export class MonthClosedForChangesError extends ErrorBase {
	static fromErrorResponse(payload: any): MonthClosedForChangesError {
		return new MonthClosedForChangesError(payload.month);
	}

	static errorId = "accounting-month-closed";

	override get displayText(): string {
		return `Änderung konnte nicht durchgeführt werden: Der Monat ${this.month} ist bereits abgeschlossen.`;
	}

	constructor(readonly month: MonthString) {
		super();
	}
}

export class ThirdPartyVouchersNotEnabledError extends ErrorBase {
	static fromErrorResponse(): ThirdPartyVouchersNotEnabledError {
		return new ThirdPartyVouchersNotEnabledError();
	}

	static errorId = "third-party-vouchers-not-enabled";

	constructor() {
		super("Belege für Drittpersonen sind nicht erlaubt in diesem Standort");
	}
}
export class ThirdPartyCategoryNotAllowedError extends ErrorBase {
	static fromErrorResponse(): ThirdPartyCategoryNotAllowedError {
		return new ThirdPartyCategoryNotAllowedError();
	}

	static errorId = "third-party-category-not-allowed";

	constructor() {
		super(
			"Die Kategorie dieses Belegs wird nicht für Belege von Drittpersonen unterstützt"
		);
	}
}

export class ModuleSettingDateRangeError extends ErrorBase {
	static errorId = "module-setting-date-range-invalid";

	constructor() {
		super(
			"Der Datumsbereich der Moduleinstellung überschneidet sich nicht mit den Vertragsdaten des Mitarbeiters."
		);
	}
}

export class ModuleSettingMaxAmountBelowUsedAmountError extends ErrorBase {
	static fromErrorResponse(
		payload: any
	): ModuleSettingMaxAmountBelowUsedAmountError {
		return new ModuleSettingMaxAmountBelowUsedAmountError(
			payload.maxAmount,
			payload.usedAmount
		);
	}

	static errorId = "module-setting-max-amount-below-used-amount";

	constructor(maxAmount: number, usedAmount: number) {
		const maxAmountStr = (maxAmount / 100).toFixed(2).replace(".", ",");
		const usedAmountStr = (usedAmount / 100).toFixed(2).replace(".", ",");
		super(
			`Der neue Budgetbetrag (${maxAmountStr}) kann nicht unter den bereits verwendeten Betrag (${usedAmountStr}) gesenkt werden.`
		);
	}
}

export class IncompatibleModuleWithAccountingMonthSettingError extends ErrorBase {
	static errorId = "incompatible-module-with-accounting-month-setting";

	constructor(readonly moduleId: string) {
		super(
			"Konfiguration nicht möglich. Bestimmte Module erfordern die Abrechnung im Folgemonat. Verwendetes Modul: " +
				moduleId
		);
	}

	static fromErrorResponse(
		payload: any
	): IncompatibleModuleWithAccountingMonthSettingError {
		return new IncompatibleModuleWithAccountingMonthSettingError(
			payload.moduleId
		);
	}
}
